import ReportBrandAttributeMapElement from './reportBrandAttributeMapElement'
export default ReportBrandAttributeMapElement
